export interface User {
  firstName: string;
  lastName: string;
  email: string;
  school: string;
  phoneNumber: string;
  avatar?: string;
}

export enum UserRole {
  Student = 'student',
  Teacher = 'teacher',
  parent = 'parent',
  Admin = 'admin',
  SuperAdmin = 'super-admin',
}

export enum UserStatus {
  Premium = 'premium',
  Free = 'free',
}
